export function createSyncConfigForm (extra = {}) {
  return {
    id: undefined,
    enabled: 1,
    taskName: '',
    peerPriceRate: undefined,
    commissionRate: undefined,
    marketPriceRate: undefined,
    purchasePriceRate: undefined,
    syncType: undefined,
    productIds: '',
    productInfoInterval: undefined,
    productInfoStrategy: undefined,
    priceStockInterval: undefined,
    priceStockStrategy: undefined,
    ...extra
  }
}

export const syncConfigFormRules = {
  peerPriceRate: [
    { required: true, message: '请填写同行价比例', trigger: 'change' },
    { type: 'number', min: 1, max: 100, message: '同行价可设置 1%~100%', trigger: 'change' }
  ],
  commissionRate: [
    { required: true, message: '请填写佣金比例', trigger: 'change' },
    { type: 'number', min: 0, max: 100, message: '佣金可设置 0%~100%', trigger: 'change' }
  ],
  marketPriceRate: [
    { required: true, message: '请填写市场价比例', trigger: 'change' },
    { type: 'number', min: 100, max: 1000, message: '市场价可设置 100%~1000%', trigger: 'change' }
  ],
  purchasePriceRate: [
    { required: true, message: '请填写采购价比例', trigger: 'change' },
    { type: 'number', min: 1, max: 100, message: '采购价可设置 1%~100%', trigger: 'change' }
  ],
  syncType: [
    { required: true, message: '请选择同步商品方式', trigger: 'change' }
  ],
  productInfoInterval: [
    { required: true, message: '请填写商品信息更新间隔', trigger: 'change' },
    { type: 'number', min: 5, message: '商品信息同步间隔建议不少于 5 分钟', trigger: 'change' }
  ],
  priceStockInterval: [
    { required: true, message: '请填写价格库存更新间隔', trigger: 'change' },
    { type: 'number', min: 5, message: '价格库存同步间隔建议不少于 5 分钟', trigger: 'change' }
  ]
}

export function getSpecifiedLineIds (record) {
  if (!record) return []
  if (Array.isArray(record.specifiedLineIds) && record.specifiedLineIds.length) {
    return record.specifiedLineIds
  }
  return (record.syncSpecifieds || [])
    .map(item => item.lineCode)
    .filter(code => code != null && code !== '')
}

export function mapDetailToForm (detail = {}) {
  return createSyncConfigForm({
    id: detail.id,
    enabled: detail.enabled,
    taskName: detail.taskName || '',
    peerPriceRate: detail.peerPricePercent,
    commissionRate: detail.commissionPercent,
    marketPriceRate: detail.marketPricePercent,
    purchasePriceRate: detail.purchasePricePercent,
    syncType: detail.syncScope,
    productIds: getSpecifiedLineIds(detail).join('\n'),
    productInfoInterval: detail.productIntervalMinutes,
    productInfoStrategy: detail.productUpdateMode,
    priceStockInterval: detail.priceIntervalMinutes,
    priceStockStrategy: detail.priceUpdateMode
  })
}

export function buildSpecifiedList (form, userInfo = {}) {
  if (form.syncType !== 2) return []
  return String(form.productIds || '')
    .split(/[\n,，]/)
    .map(item => item.trim())
    .filter(Boolean)
    .map(lineCode => ({
      merchantId: userInfo.merchantId,
      character: userInfo.merchantLoginType,
      operatorId: userInfo.superiorBossId,
      lineCode: String(lineCode)
    }))
}

export function buildSaveParams (form, userInfo = {}, options = {}) {
  const specifiedList = buildSpecifiedList(form, userInfo)
  const taskName = String(form.taskName || '').trim()
  return {
    ...(form.id != null ? { id: form.id } : {}),
    merchantId: userInfo.merchantId,
    ...(taskName ? { taskName } : {}),
    peerPricePercent: form.peerPriceRate,
    commissionPercent: form.commissionRate,
    marketPricePercent: form.marketPriceRate,
    purchasePricePercent: form.purchasePriceRate,
    syncScope: form.syncType,
    productIntervalMinutes: form.productInfoInterval,
    productUpdateMode: form.productInfoStrategy,
    priceIntervalMinutes: form.priceStockInterval,
    priceUpdateMode: form.priceStockStrategy,
    enabled: options.enabled != null
      ? options.enabled
      : (form.enabled == null ? 1 : form.enabled),
    specifiedList
  }
}

export function formatPercent (value) {
  if (value == null || value === '') return '-'
  return `${value}%`
}

export function formatLineIds (ids) {
  if (!ids || !ids.length) return '-'
  return ids.join('、')
}

export function getEnabledText (value) {
  return Number(value) === 1 ? '启用' : '屏蔽'
}

export function getSyncScopeText (value) {
  if (Number(value) === 1) return '全量同步'
  if (Number(value) === 2) return '指定产品同步'
  return '-'
}

export function getUpdateModeText (value, type) {
  if (Number(value) === 1) return '全量更新'
  if (Number(value) === 2) {
    return type === 'product' ? '仅新增' : '仅更新库存'
  }
  return '-'
}
